import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'payer-multiselect-autocomplete',
  template:
    '<multi-autocomplete-list-item [selected]="selected" [item]="item" (changed)="toggle()"> <payer-list-item [item]="item" (clicked)="toggle()"></payer-list-item></multi-autocomplete-list-item>',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class MultiAutocompletePayerListItem {
  @Input() item: any;
  @Input() selected: any[];
  @Output() checkedChange: EventEmitter<any> = new EventEmitter<any>();
  toggle() {
    this.checkedChange.emit(this.item);
  }
}
